<template>
  <div>
    QR Code Scanner
    <hr>
    <b-form-group :class="{'error-input' : $v.data_scanner.title.$error}">
      <label> Title </label>
      <j-input
        v-model="$v.data_scanner.title.$model"
        :max-length="255"
        placeholder="Title"/>
    </b-form-group>
    <b-form-group :class="{'error-input' : $v.data_scanner.description.$error}">
      <label> Description </label>
      <j-textarea
        v-model="$v.data_scanner.description.$model"
        placeholder="Description" />
    </b-form-group>
    <b-form-group :class="{'error-input' : $v.data_scanner.function_name.$error}">
      <label> Function Name </label>
      <j-single-select
        v-model="$v.data_scanner.function_name.$model"
        :options="listFunction"
        :placeholder="'Select Function Name'"
        label="name"/>
    </b-form-group>
    <div class="information">
      <img src="@/assets/icon/info.svg" >
      <div>
        <p>Information</p>
        <span>
          QR Code Scanner widget will only show on mobile view but not support for Offline Mode.
          Click
          <b-link
            href="https://docs.officeless.studio/documentation/Visual-Programming/Function-for-widget-QR-Code-Scanner?mod=4nOD53WVR&doc=RNJTrdq4g"
            target="_blank">
            <strong>here</strong>
          </b-link>
          for detailed requirements function response
        </span>
      </div>
    </div>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeScanner">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveScanner">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import jwtDecode from 'jwt-decode';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_scanner: {
      title: { required },
      description: { required },
      function_name: { required },
    },
  },
  data() {
    return {
      data_scanner: {
        title: '',
        description: '',
        function_name: null,
      },
      listFunction: [],
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
    };
  },
  computed: {
    generateDataScanner() {
      const data = {
        info: JSON.stringify({
          title: this.data_scanner.title,
          description: this.data_scanner.description,
          function_name: this.data_scanner.function_name,
        }),
        name: this.data_scanner.title,
        widget_master_id: this.dataMaster.id,

        type: 1,
        position: this.dataMaster.position,
      };
      return data;
    },

    generateDataScannerUpdate() {
      const data = {
        info: JSON.stringify({
          title: this.data_scanner.title,
          description: this.data_scanner.description,
          function_name: this.data_scanner.function_name,
        }),
        name: this.data_scanner.title,
        widget_master_id: this.dataMaster.id,

        type: 1,
        position: this.dataMaster.position,
        order: this.dataEdit.order,
      };
      return data;
    },
  },
  mounted() {
    this.getListFunction();
    if (this.modeEdit) {
      this.data_scanner.title = JSON.parse(this.dataEdit.info).title;
      this.data_scanner.description = JSON.parse(this.dataEdit.info).description;
      this.data_scanner.function_name = JSON.parse(this.dataEdit.info).function_name;
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveWidget', 'updateWidget']),
    ...mapActions('jStoreAutomation', ['getDetailAutomation']),

    saveScanner() {
      this.$v.data_scanner.$touch();
      if (!this.$v.data_scanner.$error) {
        if (!this.modeEdit) {
          const dataParam = this.generateDataScanner;
          this.saveWidget(dataParam);
        } else {
          const widgetId = this.dataEdit.id;
          const dataParam = this.generateDataScannerUpdate;
          this.updateWidget({ widgetId, dataParam });
        }
        this.closeScanner();
      }
    },

    closeScanner() {
      this.$emit('close-field');
      this.data_scanner.channel = null;
      setTimeout(() => {
        this.$v.data_scanner.$reset();
      }, 1000);
    },

    getListFunction() {
      const dataFilter = {
        company_id: this.session.user.company_id,
      };
      dataFilter['trigger.type'] = 'function';
      const param = {
        limit: 1000000,
        page: 1,
        sort: { created_at: -1 },
        filter: JSON.stringify(dataFilter),
      };
      this.getDetailAutomation(param).then((res) => {
        this.listFunction = res.data.data.map(e => ({
          id: e.trigger.function ? e.trigger.function.name : '',
          name: e.trigger.function ? e.trigger.function.name : '',
        }));
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/widget/widget-component/jQRCodeSetup.vue